import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'lib-ribera-loader-ui',
  imports: [ProgressSpinnerModule],
  templateUrl: './ribera-loader-ui.html',
  styleUrl: './ribera-loader-ui.scss',
})
export class RiberaLoaderUi {
  @Input() loader = false;
}
